module.exports = __webpack_public_path__ + "b7c9409ec27438a6f354e440ac5917f9.jpg";